import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useState } from "react";
import { PendingButton } from "@ploy-ui/core";
import Icon from "@material-ui/core/Icon";
import { modals } from "../../components/modals";
import { isButtonColor, isButtonVariant } from "./ButtonCommon";
import { DployFormControl } from "@ploy-ui/form-fields";
export const OpenModalButton = memo(({ label, color, variant, icon, fullWidth, disabled, field: { value }, margin }) => {
    const buttonColor = isButtonColor(color) ? color : undefined;
    const buttonVariant = isButtonVariant(variant) ? variant : undefined;
    const [isOpen, setOpen] = useState(false);
    const labelIcon = icon && typeof icon === "string" ? _jsx(Icon, { className: icon }) : icon;
    const onClickHandler = () => setOpen(true);
    const onCloseHandler = () => setOpen(false);
    const ModalComponent = modals[value];
    return (_jsxs(DployFormControl, { margin: margin, fullWidth: fullWidth, children: [_jsx(PendingButton, { color: buttonColor, variant: buttonVariant, fullWidth: fullWidth, disabled: disabled, pending: false, size: "large", onClick: onClickHandler, endIcon: labelIcon, children: label }), _jsx(ModalComponent, { open: isOpen, handleClose: onCloseHandler })] }));
});
OpenModalButton.displayName = "OpenModalButton";
//# sourceMappingURL=OpenModalButton.js.map